import { ISistema } from "../interface-system/system-interface";
import { EnumPadrao, TipoMensagem, CabecalhoMensagens } from "../enums/Enumarations";
import { Router, ActivatedRoute } from "@angular/router";
import { PadraoService } from "../../../service/padrao.service";
import { bObservableUsuario, ObservableBlockPanel } from "../../../util/observable-util";
import { ConfirmationService, Message } from "primeng/primeng";
/**
 * Implementação Base da interface ISistema deve ser extendida para as classes de sistemas filhas
 */
export class BaseImplemantation implements ISistema {
    /**
     * Construtor do sistema registro, esse construtor deve possuir os mesmos dados usados na interface SistemaConstrutor
     */
    constructor(
        public router: Router,
        public activatedRoute: ActivatedRoute,
        public service: PadraoService,
        public confirmacao: ConfirmationService,
        public msgs: Message[],
        public bObservable: bObservableUsuario,
        public observableUtilPanel: ObservableBlockPanel
    ) { };
    perfilLotado: any[] = [];
    situacaoAlter: any = EnumPadrao;
    perfilRestrict: any = EnumPadrao;
    situacaoRestric: any = EnumPadrao;
    situacaoPerfilRestric:any = EnumPadrao;
    perfilSituacaoRestric:any = EnumPadrao;
    variableComparable: any = EnumPadrao;
    componentsAppMenu: any[] = [];
    perfilGestor:string;

    reader = new FileReader();

    /**
     * Objecto para configuração do relatório a ser gerado
     */
    reportConfig = {
        nameReport: '',
        formatReport: '',
        dataSetName: ''
    };
    /**
     * Método a ser usado para inicializar variaveis e outros nas classes filhas.
     */
    init() {
     };
    /**
     * Inicia o observable, assim sempre que atualizar o observable a variavel perfilLotado irá alterar de acordo.
     */
    ngOnInit() {
        this.init();
    }

    undefinedMethod(value1?: any, value2?: any, value3?: any, value4?: any, value5?: any, value6?: any, value7?: any, value8?: any, value9?: any, value10?: any) {
        return true;
    };

    dataTableFunction(event?: any, controllerName?: any, filtro?: any, situacao?: any, listagem?: any,
        value6?: any, value7?: any, value8?: any, value9?: any, value10?: any) { }

    dataTableAction(event?: any, controllerName?: any, filtro?: any, situacao?: any, listagem?: any,
        value6?: any, value7?: any, value8?: any, value9?: any, value10?: any) { }

    showMsg(severity: string, summary: string, detail: string) {
        this.msgs.push({ severity: severity, summary: summary, detail: detail });
    }
    /**
     * NÃO ALTERAR ESSE MÉTODO! 
     * Servico de validacao padrao para todos os sistemas, caso seja necessário implementar no objeto filho e criar as restrições de acordo com a necessidade.
     * @param situacao 
     */
    validAction(situacao: number): any {
        this.bObservable.getValue.subscribe(lotacao => {
            if (lotacao){
                var userInfo = lotacao.obj;
                this.perfilLotado = userInfo.lotacaoDTO.find(x => x.id == localStorage.getItem('lotacao')).perfilDTO;
                this.perfilGestor = !this.perfilLotado.some(x => x.nome == 'Gestor CRC Registro' || x.nome == 'Gestor CRC' ||x.nome == 'Gestor CFC' ||x.nome == 'Administrador EPC' ||x.nome == 'Administrador Registro')?'Profissional':'Gestor';
            }
        });
        if (this.situacaoRestric[situacao] != undefined) {
            this.showMsg(TipoMensagem[3], CabecalhoMensagens[3], this.situacaoRestric[situacao]);
            return false;
        } else if (this.situacaoRestric[situacao] == undefined && this.perfilRestrict[this.perfilGestor] != undefined) {
            this.showMsg(TipoMensagem[3], CabecalhoMensagens[3], this.perfilRestrict[this.perfilGestor]);
            return false;
        } 
        else if (this.situacaoPerfilRestric[situacao] != undefined && this.perfilSituacaoRestric[this.perfilGestor] != undefined) {
            this.showMsg(TipoMensagem[3], CabecalhoMensagens[3], this.situacaoPerfilRestric[situacao]);
            return false;
        } 
        else if (this.situacaoRestric[situacao] == undefined && this.perfilRestrict[situacao] == undefined) {
            return true;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/base/use-system/implementation-system/base-system-implementation.ts